// Doble Uve · lógica compartida: carrito lateral (Cart AJAX API + Section Rendering), añadir rápido,
// tostadas, menú móvil, cuentas atrás, vídeo de portada y reseñas. Se carga como módulo en todas las páginas.
import { StandardEvents } from '@shopify/events';

const CONFIG = window.DBU_TIENDA;
const $ = (s, el = document) => el.querySelector(s);
const $$ = (s, el = document) => [...el.querySelectorAll(s)];
const reducido = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
const SECCION_CARRITO = 'dbu-carrito';
const escapar = (t) => String(t ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

// ---------- Precios con el formato de la tienda, sin ",00" (como money_without_trailing_zeros) ----------
const dinero = (centimos) => {
  const n = centimos / 100;
  const formato = CONFIG.moneda || '{{amount_with_comma_separator}} €';
  const con = (dec, miles, sep) => {
    const [ent, frac] = n.toFixed(dec).split('.');
    const e = ent.replace(/\B(?=(\d{3})+(?!\d))/g, miles);
    return frac && Number(frac) ? `${e}${sep}${frac}` : e;
  };
  return formato.replace(/\{\{\s*(\w+)\s*\}\}/, (_, tipo) => ({
    amount: con(2, ',', '.'),
    amount_no_decimals: con(0, ',', '.'),
    amount_with_comma_separator: con(2, '.', ','),
    amount_no_decimals_with_comma_separator: con(0, '.', ','),
    amount_with_apostrophe_separator: con(2, "'", '.'),
  }[tipo] ?? con(2, '.', ',')));
};

// Bloquea el scroll de la página con los paneles abiertos. Horizon hace scroll en .page-wrapper en escritorio
// y en el documento en móvil; su CSS bloquea ambos con html[scroll-lock].
const bloquearScroll = (si) => document.documentElement.toggleAttribute('scroll-lock', si);

// ---------- Tostada ----------
let tTostada;
const tostada = (texto) => {
  const el = $('#tostada');
  if (!el) return;
  el.textContent = texto;
  el.classList.add('visible');
  clearTimeout(tTostada);
  tTostada = setTimeout(() => el.classList.remove('visible'), 2800);
};

// ---------- Carrito ----------
const carrito = () => $('#carrito');
const pintarBurbuja = (n, saltar) => {
  $$('[data-burbuja]').forEach((b) => {
    b.textContent = n;
    b.hidden = n === 0;
    if (saltar) { b.classList.remove('salta'); void b.offsetWidth; b.classList.add('salta'); }
  });
};

// Sustituye solo las partes que cambian; #dbu-entrega (día y franja) se queda como está
const aplicarSeccion = (html, saltar = false) => {
  if (!html) return;
  const doc = new DOMParser().parseFromString(html, 'text/html');
  $$('[data-parte]', doc).forEach((nueva) => {
    const actual = $(`#carrito [data-parte="${nueva.dataset.parte}"]`);
    if (!actual) return;
    actual.innerHTML = nueva.innerHTML;
    actual.hidden = nueva.hidden;
  });
  const n = Number($('[data-cantidad-total]', doc)?.textContent || 0);
  const entrega = $('#carrito [data-entrega]');
  if (entrega) entrega.hidden = n === 0;
  pintarBurbuja(n, saltar);
  actualizarEntrega();
};

const refrescarCarrito = async () => {
  const r = await fetch(`${CONFIG.rutas.raiz.replace(/\/$/, '')}/?sections=${SECCION_CARRITO}`);
  if (r.ok) aplicarSeccion((await r.json())[SECCION_CARRITO]);
};

let ultimoFoco = null;
const abrirCarrito = () => {
  const c = carrito();
  if (!c) { location.href = CONFIG.rutas.carrito; return; }
  ultimoFoco = document.activeElement;
  c.classList.add('abierto');
  c.setAttribute('aria-hidden', 'false');
  $('[data-velo]')?.classList.add('abierto');
  bloquearScroll(true);
  setTimeout(() => $('[data-cerrar-carrito]', c)?.focus({ preventScroll: true }), 50);
  requestAnimationFrame(() => revisarFlechas());
};
const cerrarCarrito = () => {
  const c = carrito();
  if (!c?.classList.contains('abierto')) return;
  c.classList.remove('abierto');
  c.setAttribute('aria-hidden', 'true');
  $('[data-velo]')?.classList.remove('abierto');
  bloquearScroll(false);
  ultimoFoco?.focus?.({ preventScroll: true });
};

const ocupado = (boton, si) => {
  if (!boton) return;
  boton.toggleAttribute('aria-busy', si);
  boton.disabled = si;
};

/**
 * Añade al carrito. items: [{ id, quantity, properties }]
 * Devuelve true si se añadió; si Shopify lo rechaza (sin stock), avisa con su mensaje.
 */
const anadir = async (items, { boton = null, abrir = false, nombre = '' } = {}) => {
  ocupado(boton, true);
  try {
    const r = await fetch(CONFIG.rutas.anadir, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections: SECCION_CARRITO, sections_url: location.pathname }),
    });
    const datos = await r.json();
    if (!r.ok) { tostada(datos.description || datos.message || 'No hemos podido añadirlo. Inténtalo de nuevo.'); return false; }
    aplicarSeccion(datos.sections?.[SECCION_CARRITO], true);
    document.dispatchEvent(new CustomEvent('dbu:carrito'));
    if (abrir || carrito()?.classList.contains('abierto')) { abrirCarrito(); return true; }
    if (boton) {
      const etiqueta = $('span', boton) || boton;
      const antes = etiqueta.textContent;
      boton.classList.add('hecho');
      etiqueta.textContent = 'Añadido';
      setTimeout(() => { boton.classList.remove('hecho'); etiqueta.textContent = antes; }, 1600);
    }
    const titulo = nombre || datos.items?.[0]?.product_title || 'Producto';
    tostada(`${titulo} añadido a tu pedido`);
    return true;
  } catch {
    tostada('No hemos podido añadirlo. Revisa la conexión e inténtalo de nuevo.');
    return false;
  } finally {
    ocupado(boton, false);
  }
};

const cambiarLinea = async (clave, cantidad, boton) => {
  ocupado(boton, true);
  try {
    const r = await fetch(CONFIG.rutas.cambiar, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: clave, quantity: cantidad, sections: SECCION_CARRITO, sections_url: location.pathname }),
    });
    const datos = await r.json();
    if (!r.ok) { tostada(datos.description || 'No hay más unidades disponibles.'); return; }
    aplicarSeccion(datos.sections?.[SECCION_CARRITO]);
    document.dispatchEvent(new CustomEvent('dbu:carrito'));
  } finally {
    ocupado(boton, false);
  }
};

// ---------- Día y franja de recogida o entrega (sustituye a la app de entregas) ----------
// Se eligen solo en el carrito, para todo el pedido, y se guardan en los atributos del carrito, que Shopify
// copia al pedido: "Fecha de recogida o entrega" (legible), "_fecha" (AAAA-MM-DD, para el CRM) y "Franja
// horaria". Las franjas salen al elegir el día y tienen cupo por producto (CRM en la Fase 3). Recogida o
// envío se elige después en el checkout. Sin día y franja no se puede ir al pago.
const DIAS_CORTOS = ['Dom', 'Lun', 'Mar', 'Mié', 'Jue', 'Vie', 'Sáb'];
const DIAS_LARGOS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
const MESES = ['enero', 'febrero', 'marzo', 'abril', 'mayo', 'junio', 'julio', 'agosto', 'septiembre', 'octubre', 'noviembre', 'diciembre'];
const MESES_CORTOS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];
const fechaLarga = (d) => `${DIAS_LARGOS[d.getDay()]} ${d.getDate()} de ${MESES[d.getMonth()]}`;
const fechaIso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
const desdeIso = (t) => { const [a, m, d] = String(t || '').split('-').map(Number); return a && m && d ? new Date(a, m - 1, d) : null; };
// Hoy y la hora en Madrid, sea cual sea la zona horaria del visitante
const ahoraMadrid = () => {
  const p = Object.fromEntries(new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' })
    .formatToParts(new Date()).map((x) => [x.type, x.value]));
  return { hoy: new Date(Number(p.year), Number(p.month) - 1, Number(p.day)), hora: `${p.hour}:${p.minute}` };
};

const entrega = () => $('[data-entrega-fechas]');
const datosEntrega = () => entrega()?.dataset || {};
const leerJson = (sel, porDefecto) => { try { return JSON.parse($(sel)?.textContent || '') ?? porDefecto; } catch { return porDefecto; } };
const configEntrega = () => leerJson('[data-entrega-config]', {});
// Productos del pedido (los pinta Liquid con el carrito, así que siempre están al día)
const lineasCarrito = () => leerJson('#carrito [data-lineas-entrega]', []);
const lineasTexto = (t) => String(t || '').split(/\r?\n/).map((x) => x.trim()).filter(Boolean);
// Para comparar nombres sin mayúsculas ni tildes ("Roscón" = "roscon")
const normal = (t) => String(t || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim();
const listaNombres = (l) => (l.length < 2 ? l.join('') : `${l.slice(0, -1).join(', ')} y ${l[l.length - 1]}`);
const fechaCorta = (d) => `${d.getDate()} de ${MESES[d.getMonth()]}`;

// ---------- Calendario del CRM ----------
// Con la URL de cupos del CRM puesta, el calendario (franjas de cada día, cierres, antelación de 48 h, campañas y
// productos que no se venden algunos días) sale de <CRM>/api/publico/calendario. Si no responde en 4 s, se usan los
// ajustes del tema como hasta ahora.
let calendarioCrm = null;
let pidiendoCalendario = null;
const urlCalendarioCrm = () => {
  const u = String((configEntrega().cupos || {}).url || '').trim();
  return u ? u.replace(/\/cupos\/?(\?.*)?$/, '/calendario') : '';
};
const cargarCalendarioCrm = async () => {
  const url = urlCalendarioCrm();
  if (!url) return null;
  pidiendoCalendario ??= (async () => {
    try {
      const r = await fetch(`${url}?dias=120`, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout?.(4000) });
      if (!r.ok) return null;
      const c = await r.json();
      if (!Array.isArray(c.dias)) return null;
      return { ...c, porDia: Object.fromEntries(c.dias.map((d) => [d.fecha, d])) };
    } catch { return null; }
  })();
  calendarioCrm = await pidiendoCalendario;
  return calendarioCrm;
};
// Por qué un día del CRM no vale para este carrito (o '' si vale)
const motivoDiaCrm = (d) => {
  if (!d.abierto) return 'Cerrado';
  if (!d.franjas.some((f) => f.reservable)) return 'Completo';
  const handles = lineasCarrito().map((l) => l.handle);
  if (d.noDisponibles.some((h) => handles.includes(h))) return 'No disponible';
  if (d.soloProductos && handles.some((h) => !d.soloProductos.includes(h))) return 'No disponible';
  return '';
};

// ---------- Campaña (roscón): si el pedido lleva un producto de campaña, solo valen sus días ----------
// Devuelve la campaña en curso o la siguiente: { desde, hasta, productos }
const campanaCarrito = (hoy) => {
  if (calendarioCrm) {
    const lineas = lineasCarrito();
    const c = (calendarioCrm.campanas || []).find((x) => lineas.some((l) => x.handles.includes(l.handle)) && desdeIso(x.hasta) >= hoy);
    return c ? { desde: desdeIso(c.desde), hasta: desdeIso(c.hasta), productos: [...new Set(lineas.filter((l) => c.handles.includes(l.handle)).map((l) => l.titulo))] } : null;
  }
  const productos = lineasCarrito().filter((l) => l.campana).map((l) => l.titulo);
  const { inicio = '', fin = '' } = configEntrega().campana || {};
  const [mi, di] = inicio.split('-').map(Number);
  const [mf, df] = fin.split('-').map(Number);
  if (!productos.length || !mi || !di || !mf || !df) return null;
  const cruza = mf < mi || (mf === mi && df < di); // de diciembre a enero
  const anio = hoy.getFullYear();
  let desde = new Date(anio, mi - 1, di);
  let hasta = new Date(anio + (cruza ? 1 : 0), mf - 1, df);
  // En enero sigue abierta la campaña que empezó en diciembre
  if (cruza && hoy <= new Date(anio, mf - 1, df)) { desde = new Date(anio - 1, mi - 1, di); hasta = new Date(anio, mf - 1, df); }
  if (hasta < hoy) { desde.setFullYear(desde.getFullYear() + 1); hasta.setFullYear(hasta.getFullYear() + 1); }
  return { desde, hasta, productos: [...new Set(productos)] };
};

// Días que se pueden elegir en el carrito, con su estado
const diasCarrito = () => {
  const d = datosEntrega();
  const { hoy, hora } = ahoraMadrid();
  if (calendarioCrm) {
    const campana = campanaCarrito(hoy);
    let dias = calendarioCrm.dias;
    // Se empieza por el primer día que se puede pedir (las 48 h de antelación quitan los primeros)
    const primero = dias.findIndex((x) => x.abierto && x.franjas.some((f) => f.reservable));
    dias = primero < 0 ? [] : dias.slice(primero);
    dias = campana ? dias.filter((x) => x.fecha >= fechaIso(campana.desde) && x.fecha <= fechaIso(campana.hasta)) : dias.slice(0, Number(d.dias || 21));
    return dias.map((x) => { const motivo = motivoDiaCrm(x); return { dia: desdeIso(x.fecha), iso: x.fecha, cerrado: !!motivo, txt: motivo || 'Libre' }; });
  }
  let antelacion = Number(d.antelacion || 0);
  if (d.horaLimite && /^\d{1,2}:\d{2}$/.test(d.horaLimite) && hora >= d.horaLimite.padStart(5, '0')) antelacion += 1;
  const cerradas = new Set(String(d.cerradas || '').split(',').map((x) => x.trim()).filter(Boolean));
  let primero = new Date(hoy); primero.setDate(primero.getDate() + antelacion);
  let ultimo = new Date(primero); ultimo.setDate(ultimo.getDate() + Number(d.dias || 21) - 1);
  const campana = campanaCarrito(hoy);
  if (campana) {
    if (campana.desde > primero) primero = new Date(campana.desde);
    ultimo = new Date(campana.hasta);
  }
  const lista = [];
  for (const f = new Date(primero); f <= ultimo; f.setDate(f.getDate() + 1)) {
    const dia = new Date(f);
    const cerrado = String(dia.getDay()) === d.cerrado || cerradas.has(fechaIso(dia));
    lista.push({ dia, iso: fechaIso(dia), cerrado });
  }
  return lista;
};

// ---------- Franjas horarias del día elegido ----------
const franjasDe = (dia) => {
  const crm = calendarioCrm?.porDia[fechaIso(dia)];
  if (crm) return crm.franjas.map((x) => x.franja);
  const f = configEntrega().franjas || {};
  const semana = lineasTexto(f.semana);
  const finde = lineasTexto(f.finde);
  if ((dia.getDay() === 0 || dia.getDay() === 6) && finde.length) return finde;
  return semana.length ? semana : finde;
};
const hayFranjas = () => !!$('[data-franjas]');
// Hora a la que termina una franja: la última hora del texto ("8.30 a 11 h" -> 11:00)
const horaFin = (t) => {
  const m = [...String(t).matchAll(/(\d{1,2})(?:[.:,h](\d{2}))?/g)].pop();
  return m ? `${m[1].padStart(2, '0')}:${m[2] || '00'}` : null;
};

// ---------- Cupos ----------
// Franjas completas de un día: [{ franja: '8.30 a 11 h' o '*', productos: ['roscon-500gr-copia' o 'Roscón'] }]
// Con el CRM (Fase 3): GET <URL de cupos>?fecha=AAAA-MM-DD&productos=handle:cantidad,... que responde
// { "franjas": [{ "franja": "8.30 a 11 h", "productos": ["roscon-500gr-copia"] }] } (ver RESERVAS.md).
// Si el CRM no responde, no se bloquea la compra. Sin CRM se usa la lista "Franjas completas" del editor.
const consultarCupos = async (iso) => {
  const lineas = lineasCarrito();
  if (!lineas.length) return [];
  const { url = '', completos = '' } = configEntrega().cupos || {};
  if (url) {
    try {
      const u = new URL(url);
      u.searchParams.set('fecha', iso);
      u.searchParams.set('productos', lineas.map((l) => `${l.handle}:${l.cantidad}${l.variante ? `:${encodeURIComponent(l.variante)}` : ''}`).join(','));
      const r = await fetch(u, { headers: { Accept: 'application/json' }, signal: AbortSignal.timeout?.(4000) });
      if (r.ok) return (await r.json()).franjas || [];
    } catch { /* sin respuesta: todas libres */ }
    return [];
  }
  return lineasTexto(completos).map((l) => l.split('|').map((x) => x.trim()))
    .filter(([fecha, franja, producto]) => fecha === iso && franja && producto)
    .map(([, franja, producto]) => ({ franja, productos: [producto] }));
};
// Productos del pedido que tienen el cupo lleno en una franja
const completosEn = (franja, cupos) => {
  const nombres = new Set();
  for (const c of cupos) {
    if (c.franja !== '*' && normal(c.franja) !== normal(franja)) continue;
    for (const p of c.productos || []) {
      for (const l of lineasCarrito()) if (l.handle === p || normal(l.titulo).includes(normal(p))) nombres.add(l.titulo);
    }
  }
  return [...nombres];
};

// Aviso con título e icono (la franja o el día no están disponibles)
const avisoCupo = (texto, titulo = 'Franja completa') => {
  const a = $('[data-aviso-cupo]');
  if (!a) return;
  $('[data-nota-titulo]', a).textContent = titulo;
  $('[data-nota-texto]', a).textContent = texto || '';
  a.hidden = !texto;
};
const textoCompleto = (franja, productos) =>
  `No quedan huecos de ${franja}: el cupo de ${listaNombres(productos)} está completo ese día. Elige otra hora u otro día.`;

const pintarResumen = () => {
  const d = datosEntrega();
  const r = $('[data-resumen]');
  if (!r) return;
  const dia = desdeIso(d.elegida);
  const listo = dia && (!hayFranjas() || d.franja);
  r.hidden = !listo;
  // Solo el cuándo: "recogida o envío al pagar" ya lo dice el texto de apoyo de debajo
  if (listo) $('[data-nota-texto]', r).textContent = `${fechaLarga(dia).replace(/^./, (c) => c.toUpperCase())}${d.franja ? `, de ${d.franja}` : ''}.`;
};

const comprobarPago = () => {
  const d = datosEntrega();
  const falta = !d.elegida || (hayFranjas() && !d.franja);
  $$('[data-ir-pago]').forEach((b) => { b.disabled = falta; });
  $$('[data-pago-aviso]').forEach((a) => { a.hidden = !falta; });
  pintarResumen();
  return !falta;
};

const guardarAtributos = async (atributos) => {
  const r = await fetch(`${CONFIG.rutas.raiz.replace(/\/$/, '')}/cart/update.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ attributes: atributos }),
  });
  if (!r.ok) throw new Error('carrito');
};

const guardarFranja = async (franja) => {
  await guardarAtributos({ [datosEntrega().nombreFranja || 'Franja horaria']: franja });
  const el = entrega();
  if (el) el.dataset.franja = franja;
  $$('[data-franja-carrito]').forEach((x) => x.setAttribute('aria-checked', String(x.dataset.franjaCarrito === franja)));
  comprobarPago();
};

// Calendario del mes, con flechas para cambiar de mes (antes era una fila que había que deslizar, incómoda con ratón).
// Semana de lunes a domingo. Los días que no se pueden pedir salen apagados; los cerrados o completos, tachados.
const CHEVRON = '<svg class="i" viewBox="0 0 20 20" fill="none" aria-hidden="true" focusable="false"><path d="M12.5 4.5 7 10l5.5 5.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
const INICIALES = ['L', 'M', 'X', 'J', 'V', 'S', 'D'];
const primeroDeMes = (d) => new Date(d.getFullYear(), d.getMonth(), 1);
const claveMes = (d) => d.getFullYear() * 12 + d.getMonth();
let mesVisto = null;

const pintarDiasCarrito = (foco = null) => {
  const caja = $('[data-fechas-carrito]');
  if (!caja) return;
  const elegida = datosEntrega().elegida;
  const lista = diasCarrito();
  const porIso = Object.fromEntries(lista.map((x) => [x.iso, x]));
  const abiertos = lista.filter((x) => !x.cerrado);
  if (!lista.length) { caja.innerHTML = '<p class="leyenda">Ahora mismo no hay días disponibles.</p>'; return; }
  const min = primeroDeMes(lista[0].dia);
  const max = primeroDeMes(lista[lista.length - 1].dia);
  // Al abrir: el mes del día elegido o el del primer día libre
  if (!mesVisto || claveMes(mesVisto) < claveMes(min) || claveMes(mesVisto) > claveMes(max)) {
    mesVisto = primeroDeMes(desdeIso(porIso[elegida] ? elegida : '') || abiertos[0]?.dia || lista[0].dia);
  }
  const anio = mesVisto.getFullYear();
  const mes = mesVisto.getMonth();
  const enMes = new Date(anio, mes + 1, 0).getDate();
  const hueco = (new Date(anio, mes, 1).getDay() + 6) % 7;
  // Recibe el foco con el teclado: el día elegido de este mes, o el primero libre
  const enfocable = (porIso[elegida] && !porIso[elegida].cerrado && desdeIso(elegida).getMonth() === mes && elegida)
    || abiertos.find((x) => x.dia.getMonth() === mes && x.dia.getFullYear() === anio)?.iso;
  let celdas = '<span class="cal__vacio"></span>'.repeat(hueco);
  for (let n = 1; n <= enMes; n++) {
    const dia = new Date(anio, mes, n);
    const iso = fechaIso(dia);
    const x = porIso[iso];
    if (!x) { celdas += `<span class="cal__fuera" aria-hidden="true">${n}</span>`; continue; }
    const txt = x.txt || (x.cerrado ? 'Cerrado' : 'Libre');
    celdas += `<button type="button" role="radio" class="cal__dia" data-dia-carrito="${iso}" aria-checked="${iso === elegida}" tabindex="${iso === enfocable ? 0 : -1}"${x.cerrado ? ` disabled title="${txt}"` : ''} aria-label="${fechaLarga(dia)}, ${txt.toLowerCase()}">${n}</button>`;
  }
  const nombreMes = `${MESES[mes].replace(/^./, (c) => c.toUpperCase())} ${anio}`;
  caja.innerHTML = `
    <div class="cal__cabeza">
      <button type="button" class="icono-boton icono-boton--borde cal__flecha" data-cal-mes="-1" aria-label="Mes anterior"${claveMes(mesVisto) <= claveMes(min) ? ' disabled' : ''}>${CHEVRON}</button>
      <p class="cal__mes" aria-live="polite">${nombreMes}</p>
      <button type="button" class="icono-boton icono-boton--borde cal__flecha cal__flecha--sig" data-cal-mes="1" aria-label="Mes siguiente"${claveMes(mesVisto) >= claveMes(max) ? ' disabled' : ''}>${CHEVRON}</button>
    </div>
    <div class="cal__semana" aria-hidden="true">${INICIALES.map((l) => `<span>${l}</span>`).join('')}</div>
    <div class="cal__dias" role="radiogroup" aria-labelledby="etiqueta-dia-carrito" aria-describedby="cal-leyenda">${celdas}</div>
    <p class="leyenda cal__leyenda" id="cal-leyenda">Los días tachados están cerrados o completos.</p>`;
  if (foco) $(`[data-dia-carrito="${foco}"]`, caja)?.focus();
};

// Cambiar de mes con las flechas
document.addEventListener('click', (e) => {
  const b = e.target.closest('[data-cal-mes]');
  if (!b || b.disabled || !mesVisto) return;
  mesVisto = new Date(mesVisto.getFullYear(), mesVisto.getMonth() + Number(b.dataset.calMes), 1);
  pintarDiasCarrito();
});
// Teclado: flechas para moverse entre días libres (también cambian de mes), Inicio y Fin de la semana
document.addEventListener('keydown', (e) => {
  const b = e.target.closest?.('[data-dia-carrito]');
  if (!b) return;
  const paso = { ArrowLeft: -1, ArrowRight: 1, ArrowUp: -7, ArrowDown: 7 }[e.key];
  if (!paso) return;
  e.preventDefault();
  const libres = new Set(diasCarrito().filter((x) => !x.cerrado).map((x) => x.iso));
  const d = desdeIso(b.dataset.diaCarrito);
  for (let i = 0; i < 62; i++) {
    d.setDate(d.getDate() + paso);
    const iso = fechaIso(d);
    if (!libres.has(iso)) continue;
    if (d.getMonth() !== mesVisto.getMonth() || d.getFullYear() !== mesVisto.getFullYear()) mesVisto = primeroDeMes(d);
    pintarDiasCarrito(iso);
    return;
  }
});

const pintarCampana = () => {
  const p = $('[data-entrega-campana]');
  if (!p) return;
  const c = campanaCarrito(ahoraMadrid().hoy);
  p.hidden = !c;
  if (c) $('[data-nota-texto]', p).textContent = `${listaNombres(c.productos)} se prepara${c.productos.length > 1 ? 'n' : ''} del ${fechaCorta(c.desde)} al ${fechaCorta(c.hasta)}: elige uno de esos días para todo el pedido.`;
};

// Franjas del día elegido, con los cupos consultados en directo. Si el día cambia mientras tanto, la respuesta vieja se ignora.
let turnoFranjas = 0;
const pintarFranjas = async () => {
  const el = entrega();
  const caja = $('[data-franjas]');
  if (!el || !caja) { comprobarPago(); return; }
  const bloque = $('[data-franjas-bloque]', el);
  const espera = $('[data-franjas-espera]', el);
  const iso = el.dataset.elegida;
  const turno = ++turnoFranjas;
  if (!iso) {
    bloque.hidden = true; espera.hidden = false;
    comprobarPago();
    return;
  }
  const dia = desdeIso(iso);
  bloque.hidden = false; espera.hidden = true;
  caja.setAttribute('aria-busy', 'true');
  const cupos = await consultarCupos(iso);
  if (turno !== turnoFranjas) return;
  caja.removeAttribute('aria-busy');
  const { hoy, hora } = ahoraMadrid();
  const esHoy = fechaIso(hoy) === iso;
  const crm = calendarioCrm?.porDia[iso];
  const reservable = (f) => !crm || crm.franjas.find((x) => x.franja === f)?.reservable !== false;
  const franjas = franjasDe(dia).map((f) => ({ f, pasada: (esHoy && (horaFin(f) || '99') <= hora) || !reservable(f), completos: completosEn(f, cupos) }));
  const elegida = el.dataset.franja;
  caja.innerHTML = franjas.map(({ f, pasada, completos }) => {
    const estado = pasada ? (reservable(f) ? 'Pasada' : 'No disponible') : completos.length ? 'Completa' : '';
    const extra = completos.length ? ` aria-disabled="true" data-completos="${escapar(JSON.stringify(completos))}"` : '';
    return `<button type="button" role="radio" class="franja${completos.length ? ' franja--completa' : ''}" data-franja-carrito="${escapar(f)}" aria-checked="${f === elegida}"${pasada ? ' disabled' : ''}${extra}>${escapar(f)}${estado ? `<small>${estado}</small>` : ''}</button>`;
  }).join('');
  // Una franja guardada que ya no vale (se llenó o cambió el pedido) se borra y se explica por qué
  const guardada = franjas.find((x) => x.f === elegida);
  if (elegida && (!guardada || guardada.pasada || guardada.completos.length)) {
    try { await guardarFranja(''); } catch { /* se pedirá de nuevo */ }
    if (guardada?.completos.length) { avisoCupo(textoCompleto(elegida, guardada.completos)); comprobarPago(); return; }
  }
  const libres = franjas.filter((x) => !x.pasada && !x.completos.length);
  if (franjas.length && !libres.length) {
    const todos = [...new Set(franjas.flatMap((x) => x.completos))];
    avisoCupo(todos.length ? `El ${fechaLarga(dia)} ya no quedan huecos para ${listaNombres(todos)}. Elige otro día.` : `El ${fechaLarga(dia)} ya no quedan franjas. Elige otro día.`, 'Día completo');
  } else if (crm?.sinEnvio) {
    avisoCupo(`${crm.sinEnvio}. Ese día no hay envío a domicilio: elige recogida en tienda al pagar.`, 'Solo recogida');
  }
  comprobarPago();
};

// Guarda el día del pedido y borra la franja, que depende del día. Se expone en window.DBU.guardarFecha.
const guardarFecha = async (dia) => {
  const d = datosEntrega();
  const iso = dia ? fechaIso(dia) : '';
  await guardarAtributos({
    [d.nombreFecha || 'Fecha de recogida o entrega']: dia ? fechaLarga(dia) : '',
    _fecha: iso,
    [d.nombreFranja || 'Franja horaria']: '',
  });
  const el = entrega();
  if (el) {
    el.dataset.elegida = iso;
    el.dataset.franja = '';
    $('[data-fecha-texto]', el).textContent = dia ? fechaLarga(dia) : '';
    pintarDiasCarrito(iso && document.activeElement?.closest?.('[data-fechas-carrito]') ? iso : null);
  }
  await pintarFranjas();
};

// Al abrir la página y cada vez que cambia el carrito: los productos cambian la campaña y los cupos
// Pedido sin ningún día posible (por ejemplo, roscón de campaña + roscón con nata, que no se hace en la campaña):
// en vez de tachar todo el calendario sin más, se explica qué productos chocan y que hagan dos pedidos.
const notaSinDias = (texto, titulo = '') => {
  const n = $('[data-aviso-sin-dias]');
  if (!n) return;
  $('[data-nota-titulo]', n).textContent = titulo;
  $('[data-nota-texto]', n).textContent = texto || '';
  n.hidden = !texto;
  // La nota de campaña ya va dentro del mensaje: mientras se ve este aviso, sobra
  const campana = $('[data-entrega-campana]');
  if (campana && texto) campana.hidden = true;
};
const explicarSinDias = () => {
  const lista = diasCarrito();
  const sinDias = !!calendarioCrm && lista.length > 0 && !lista.some((x) => !x.cerrado);
  if (!sinDias) { notaSinDias(''); return false; }
  const lineas = lineasCarrito();
  const bloquean = new Set();
  for (const x of lista) {
    const d = calendarioCrm.porDia[x.iso];
    if (!d?.abierto) continue;
    for (const l of lineas) if (d.noDisponibles.includes(l.handle) || (d.soloProductos && !d.soloProductos.includes(l.handle))) bloquean.add(l.titulo);
  }
  const c = campanaCarrito(ahoraMadrid().hoy);
  const otros = [...bloquean].filter((t) => !c?.productos.includes(t));
  if (c && otros.length) {
    notaSinDias(`${listaNombres(otros)} no se ${otros.length > 1 ? 'hacen' : 'hace'} del ${fechaCorta(c.desde)} al ${fechaCorta(c.hasta)}, que es cuando se recoge ${listaNombres(c.productos)}. Haz dos pedidos: uno con ${listaNombres(c.productos)} y otro con ${listaNombres(otros)}.`, 'Estos productos no pueden ir juntos');
  } else if (bloquean.size) {
    const varios = bloquean.size > 1;
    notaSinDias(`${listaNombres([...bloquean])} no se ${varios ? 'pueden' : 'puede'} pedir en los próximos días. ${varios ? 'Quítalos' : 'Quítalo'} del pedido o ${varios ? 'pídelos' : 'pídelo'} más adelante.`, 'Sin días para este pedido');
  } else {
    notaSinDias('Ahora mismo no quedan días libres para este pedido. Prueba más tarde o llámanos.', 'Sin días para este pedido');
  }
  return true;
};

const actualizarEntrega = async () => {
  if (!entrega()) return;
  await cargarCalendarioCrm();
  pintarCampana();
  // Un día guardado que ya pasó, está cerrado o no es de la campaña se borra, para que no llegue un pedido con fecha imposible
  const guardada = datosEntrega().elegida;
  if (guardada && !diasCarrito().some((x) => x.iso === guardada && !x.cerrado)) {
    try { await guardarFecha(null); } catch { /* se pedirá de nuevo */ }
    if (!explicarSinDias() && campanaCarrito(ahoraMadrid().hoy)) avisoCupo('El día que tenías elegido no entra en la campaña. Elige uno de los días de abajo.', 'Elige otro día');
    return;
  }
  pintarDiasCarrito();
  explicarSinDias();
  await pintarFranjas();
};
actualizarEntrega();

document.addEventListener('click', async (e) => {
  const b = e.target.closest('[data-dia-carrito]');
  if (b && !b.disabled) {
    $$('[data-dia-carrito]').forEach((x) => x.setAttribute('aria-checked', String(x === b)));
    avisoCupo('');
    try { await guardarFecha(desdeIso(b.dataset.diaCarrito)); } catch { tostada('No hemos podido guardar el día. Inténtalo de nuevo.'); }
    return;
  }
  const f = e.target.closest('[data-franja-carrito]');
  if (f && !f.disabled) {
    // Franja completa: no se elige y se explica qué producto la llena
    if (f.getAttribute('aria-disabled') === 'true') {
      avisoCupo(textoCompleto(f.dataset.franjaCarrito, JSON.parse(f.dataset.completos || '[]')));
      return;
    }
    avisoCupo('');
    try { await guardarFranja(f.dataset.franjaCarrito); } catch { tostada('No hemos podido guardar la franja. Inténtalo de nuevo.'); }
    return;
  }
  // Cualquier botón de pago (también el de la página del carrito de Horizon) exige día y franja: si falta, se abre el carrito
  const pago = e.target.closest('[name="checkout"], a[href$="/checkout"]');
  if (pago && entrega() && !comprobarPago()) {
    e.preventDefault();
    abrirCarrito();
    setTimeout(() => entrega()?.scrollIntoView({ behavior: reducido() ? 'auto' : 'smooth', block: 'center' }), 250);
    tostada(datosEntrega().elegida ? 'Elige también la franja horaria.' : 'Elige el día de recogida o entrega.');
  }
}, true);

// Si otra parte del tema (por ejemplo la página del carrito de Horizon) cambia el carrito, se refresca
document.addEventListener(StandardEvents.cartLinesUpdate, () => { refrescarCarrito(); });
// Al volver con el botón Atrás, el carrito puede haber cambiado en otra pestaña
window.addEventListener('pageshow', (e) => { if (e.persisted) refrescarCarrito(); });

// ---------- Añadir rápido con opciones (popup en escritorio, hoja desde abajo en móvil) ----------
const icono = {
  mas: '<svg class="i" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.75 7H11.25" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/><path d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
  menos: '<svg class="i" viewBox="0 0 14 14" fill="none" aria-hidden="true"><path d="M2.75 7H11.25" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
  flecha: '<svg class="i" viewBox="0 0 20 20" fill="none" aria-hidden="true"><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4" d="M4.25 10h11.5m0 0-4-4m4 4-4 4"/></svg>',
  cerrar: '<svg class="i" viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M4 4l8 8M12 4l-8 8" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>',
};
const rapida = { p: null, v: 0, cantidad: 1, foco: null };
const pintarRapida = () => {
  const { p } = rapida;
  const v = p.variantes[rapida.v];
  const total = dinero(v.precio * rapida.cantidad);
  $('#rapida-caja').innerHTML = `
    <button class="rapida__cerrar icono-boton" type="button" aria-label="Cerrar" data-cerrar-rapida>${icono.cerrar}</button>
    <div class="rapida__media${p.estudio ? ' rapida__media--estudio' : ''}">${p.imagen ? `<img src="${p.imagen}" alt="${escapar(p.titulo)}">` : ''}</div>
    <div class="rapida__info">
      <p class="rapida__nombre" id="rapida-nombre">${escapar(p.titulo)}</p>
      <p class="precio rapida__precio">${total}</p>
      <p class="pdp__etiqueta" id="rapida-etq">${escapar(p.opcion && p.opcion !== 'Title' ? p.opcion : 'Formato')}</p>
      <div class="opciones" role="radiogroup" aria-labelledby="rapida-etq">${p.variantes.map((x, i) => `<button type="button" role="radio" class="opcion" data-rapida-v="${i}" aria-checked="${i === rapida.v}" ${x.disponible ? '' : 'disabled'}><span class="opcion__nombre">${escapar(x.titulo)}</span><span class="opcion__precio precio">${x.disponible ? dinero(x.precio) : 'Agotado'}</span></button>`).join('')}</div>
      <div class="pdp__compra">
        <div class="cantidad cantidad--grande" role="group" aria-label="Cantidad">
          <button type="button" aria-label="Quitar uno" data-rapida-cant="-1">${icono.menos}</button><span>${rapida.cantidad}</span>
          <button type="button" aria-label="Añadir uno" data-rapida-cant="1">${icono.mas}</button>
        </div>
        <button class="boton boton--ancho pdp__boton" type="button" data-rapida-anadir>Añadir · ${total}</button>
      </div>
      <a class="enlace-flecha" href="${p.url}">Ver la ficha completa ${icono.flecha}</a>
    </div>`;
};
const abrirRapida = (datos) => {
  rapida.p = datos;
  rapida.cantidad = 1;
  rapida.v = Math.max(0, datos.variantes.findIndex((v) => v.disponible));
  rapida.foco = document.activeElement;
  pintarRapida();
  const panel = $('#rapida');
  panel.hidden = false;
  requestAnimationFrame(() => requestAnimationFrame(() => panel.classList.add('abierta')));
  bloquearScroll(true);
  setTimeout(() => $('[data-cerrar-rapida]', panel)?.focus({ preventScroll: true }), 60);
};
const cerrarRapida = () => {
  const panel = $('#rapida');
  if (!panel || panel.hidden) return;
  panel.classList.remove('abierta');
  bloquearScroll(false);
  setTimeout(() => { panel.hidden = true; }, reducido() ? 0 : 320);
  rapida.foco?.focus?.({ preventScroll: true });
};

// ---------- Buscador de la cabecera (búsqueda predictiva de Shopify, sin salir de la página) ----------
// Mientras se escribe pide los resultados a sections/dbu-busqueda.liquid; Enter envía el formulario a /search.
const buscador = $('[data-buscador]');
if (buscador) {
  document.body.append(buscador); // fuera de la cabecera, para que quede por encima de todo
  const campo = $('[data-buscador-campo]', buscador);
  const caja = $('[data-buscador-resultados]', buscador);
  const sugeridas = $('[data-buscador-sugeridas]', buscador);
  let pedido = null;
  let espera = null;
  let focoAntes = null;

  const buscar = async (q) => {
    pedido?.abort();
    if (q.length < 2) { caja.innerHTML = ''; if (sugeridas) sugeridas.hidden = false; return; }
    pedido = new AbortController();
    caja.setAttribute('aria-busy', 'true');
    try {
      const url = `${CONFIG.rutas.raiz.replace(/\/$/, '')}/search/suggest?q=${encodeURIComponent(q)}`
        + '&resources[type]=product,query&resources[limit]=8&resources[options][unavailable_products]=last&section_id=dbu-busqueda';
      const r = await fetch(url, { signal: pedido.signal });
      if (!r.ok) throw new Error('busqueda');
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const respuesta = $('[data-buscador-respuesta]', doc);
      caja.innerHTML = respuesta ? respuesta.outerHTML : '';
      if (sugeridas) sugeridas.hidden = true;
    } catch (e) {
      if (e.name !== 'AbortError') caja.innerHTML = '<p class="leyenda">No hemos podido buscar ahora. Pulsa Enter para ver los resultados.</p>';
    } finally {
      caja.setAttribute('aria-busy', 'false');
    }
  };

  const abrirBuscador = () => {
    focoAntes = document.activeElement;
    cerrarCarrito();
    buscador.hidden = false;
    requestAnimationFrame(() => requestAnimationFrame(() => buscador.classList.add('abierto')));
    $$('[data-abrir-buscador]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    bloquearScroll(true);
    campo.focus({ preventScroll: true });
    campo.select();
  };
  const cerrarBuscador = () => {
    if (buscador.hidden) return;
    buscador.classList.remove('abierto');
    $$('[data-abrir-buscador]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    bloquearScroll(false);
    setTimeout(() => { buscador.hidden = true; }, reducido() ? 0 : 220);
    focoAntes?.focus?.({ preventScroll: true });
  };

  campo.addEventListener('input', () => {
    clearTimeout(espera);
    espera = setTimeout(() => buscar(campo.value.trim()), 220);
  });
  // Enter: el formulario va a /search (página de resultados) sin esperar al ajax
  buscador.querySelector('form').addEventListener('submit', (e) => { if (!campo.value.trim()) e.preventDefault(); });
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-abrir-buscador]')) { e.preventDefault(); abrirBuscador(); return; }
    if (e.target.closest('[data-cerrar-buscador]')) { cerrarBuscador(); return; }
    const s = e.target.closest('[data-buscar]');
    if (s) { campo.value = s.dataset.buscar; campo.focus(); buscar(campo.value); return; }
    // Al añadir con opciones o al abrir el carrito desde un resultado, el buscador deja paso
    if (!buscador.hidden && e.target.closest('#buscador [data-ver-opciones], #buscador [data-abrir-carrito]')) cerrarBuscador();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !buscador.hidden && ($('#rapida')?.hidden ?? true)) { e.stopImmediatePropagation(); cerrarBuscador(); }
    // "/" abre el buscador en escritorio, como en muchas tiendas
    if (e.key === '/' && buscador.hidden && !e.target.closest('input, textarea, select, [contenteditable]')) { e.preventDefault(); abrirBuscador(); }
  }, true);
  window.DBU_BUSCADOR = { abrir: abrirBuscador, cerrar: cerrarBuscador };
}

// ---------- Eventos globales ----------
document.addEventListener('click', (e) => {
  const t = e.target.closest('button, a');
  if (!t) return;
  if (t.matches('[data-abrir-carrito]')) { e.preventDefault(); return abrirCarrito(); }
  if (t.matches('[data-cerrar-carrito]')) return cerrarCarrito();
  if (t.matches('[data-anadir]')) return anadir([{ id: Number(t.dataset.anadir), quantity: 1 }], { boton: t.closest('.mini') ? null : t });
  if (t.matches('[data-linea]')) return cambiarLinea(t.dataset.linea, Number(t.dataset.cantidad), t);
  if (t.matches('[data-ver-opciones]')) {
    const json = $('[data-producto-json]', t.closest('[data-tarjeta]'));
    if (json) return abrirRapida(JSON.parse(json.textContent));
  }
  if (t.matches('[data-cerrar-rapida]')) return cerrarRapida();
  if (t.matches('[data-rapida-v]')) { rapida.v = Number(t.dataset.rapidaV); return pintarRapida(); }
  if (t.matches('[data-rapida-cant]')) { rapida.cantidad = Math.max(1, Math.min(20, rapida.cantidad + Number(t.dataset.rapidaCant))); return pintarRapida(); }
  if (t.matches('[data-rapida-anadir]')) {
    const v = rapida.p.variantes[rapida.v];
    const nombre = `${rapida.p.titulo} (${v.titulo.toLowerCase()})`;
    cerrarRapida();
    return anadir([{ id: v.id, quantity: rapida.cantidad }], { abrir: true, nombre });
  }
  if (t.matches('[data-menu]')) {
    const menu = $('#menu-movil');
    menu.hidden = !menu.hidden;
    t.setAttribute('aria-expanded', String(!menu.hidden));
    return;
  }
  if (t.matches('[data-desplazar]')) {
    const pista = document.getElementById(t.dataset.desplazar);
    pista?.scrollBy({ left: Number(t.dataset.dir) * pista.clientWidth * 0.8, behavior: reducido() ? 'auto' : 'smooth' });
  }
});
// Flechas de una fila deslizable: se apagan al llegar a un extremo y se ocultan si todo cabe
const estadoFlechas = (pista) => {
  const fin = pista.scrollWidth - pista.clientWidth;
  $$(`[data-desplazar="${pista.id}"]`).forEach((x) => { x.disabled = Number(x.dataset.dir) < 0 ? pista.scrollLeft <= 2 : pista.scrollLeft >= fin - 2; });
  const grupo = $(`[data-flechas-de="${pista.id}"]`);
  if (grupo) grupo.hidden = fin <= 2;
};
document.addEventListener('scroll', (e) => { if (e.target.matches?.('[data-pista-flechas]')) estadoFlechas(e.target); }, { capture: true, passive: true });
const revisarFlechas = () => $$('[data-pista-flechas]').forEach(estadoFlechas);
document.addEventListener('dbu:carrito', () => requestAnimationFrame(revisarFlechas));
window.addEventListener('resize', revisarFlechas, { passive: true });
revisarFlechas();
document.addEventListener('click', (e) => { if (e.target.matches('[data-velo]')) cerrarCarrito(); });
document.addEventListener('click', (e) => { if (e.target.matches('[data-fondo-rapida]')) cerrarRapida(); });
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  if ($('#rapida') && !$('#rapida').hidden) return cerrarRapida();
  cerrarCarrito();
});

// Sombra de la cabecera al bajar (IntersectionObserver, sin escuchar el scroll)
const centinela = document.createElement('div');
centinela.setAttribute('aria-hidden', 'true');
centinela.style.cssText = 'position:absolute;top:120px;height:1px;width:1px;pointer-events:none';
// En escritorio Horizon hace scroll dentro de .page-wrapper: el centinela tiene que ir dentro
($('.page-wrapper') || document.body).prepend(centinela);
new IntersectionObserver(([en]) => $('#cabecera')?.classList.toggle('con-sombra', !en.isIntersecting)).observe(centinela);

// Menú hamburguesa automático: si los enlaces no caben junto al logo (pantallas medianas, menús largos),
// la cabecera pasa a .cabecera--compacta. Se mide quitando la clase y volviéndola a poner en el mismo
// fotograma, así que no parpadea.
const cabecera = $('#cabecera');
const navPrincipal = cabecera?.querySelector('.cabecera__nav');
if (cabecera && navPrincipal) {
  const barra = cabecera.querySelector('.cabecera__barra');
  const ajustarMenu = () => {
    cabecera.classList.remove('cabecera--compacta');
    const enlaces = navPrincipal.children;
    const visible = getComputedStyle(navPrincipal).display !== 'none' && enlaces.length > 0;
    // Ancho que ocupan los enlaces frente al de su columna (rejilla 1fr auto 1fr), con 24 px de aire hasta el logo
    const ocupado = visible ? enlaces[enlaces.length - 1].getBoundingClientRect().right - enlaces[0].getBoundingClientRect().left : 0;
    const compacta = !visible || ocupado > navPrincipal.clientWidth - 24;
    cabecera.classList.toggle('cabecera--compacta', compacta);
    if (!compacta) {
      const menu = $('#menu-movil');
      if (menu && !menu.hidden) { menu.hidden = true; $('[data-menu]')?.setAttribute('aria-expanded', 'false'); }
    }
  };
  new ResizeObserver(ajustarMenu).observe(barra);
  document.fonts?.ready.then(ajustarMenu);
}

// Cinta de categorías: la segunda vuelta (para el movimiento continuo) es una copia de la primera
const copiarCintas = () => $$('[data-cinta-copia]').forEach((copia) => {
  const original = copia.previousElementSibling;
  if (!original || copia.childElementCount) return;
  copia.append(...[...original.children].map((n) => {
    const c = n.cloneNode(true);
    c.setAttribute('tabindex', '-1');
    c.removeAttribute('data-shopify-editor-block');
    return c;
  }));
});
copiarCintas();
// En el editor del tema la sección se vuelve a pintar al cambiar un ajuste
document.addEventListener('shopify:section:load', copiarCintas);

// Cuentas atrás (aviso, fichas especiales): se recalculan en el navegador por si la página viene de caché
const diasHasta = (mmdd) => {
  const [m, d] = mmdd.split('-').map(Number);
  if (!m || !d) return null;
  const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
  let meta = new Date(hoy.getFullYear(), m - 1, d);
  if (meta < hoy) meta = new Date(hoy.getFullYear() + 1, m - 1, d);
  return Math.round((meta - hoy) / 864e5);
};
$$('[data-dias-hasta]').forEach((el) => { const n = diasHasta(el.dataset.diasHasta); if (n !== null) el.textContent = n; });

// Vídeo de la portada: lo primero que se ve es la foto fija (LCP) y el vídeo se descarga cuando la página
// ya ha cargado. En móvil, la versión ligera. Con "reducir movimiento" o ahorro de datos se queda la foto.
const videoHero = $('[data-video-hero]');
if (videoHero) {
  videoHero.arrancar = () => {
    if (videoHero.src) return;
    const movil = !matchMedia('(min-width: 900px)').matches;
    videoHero.src = (movil && videoHero.dataset.srcMovil) || videoHero.dataset.src;
    videoHero.addEventListener('playing', () => videoHero.classList.add('reproduciendo'), { once: true });
    videoHero.play().catch(() => {});
  };
  if (!reducido() && !navigator.connection?.saveData) {
    const cuando = () => ('requestIdleCallback' in window ? requestIdleCallback(videoHero.arrancar, { timeout: 2500 }) : setTimeout(videoHero.arrancar, 400));
    if (document.readyState === 'complete') cuando(); else window.addEventListener('load', cuando, { once: true });
  }
}

// Vídeos a sangre: botón de pausa y respeto a "reducir movimiento"
const botonesPausa = [['[data-pausa-video]', '.hero-b'], ['[data-pausa-pdp]', '.pdp-video']];
const ponerPausa = (boton, video, pausado) => {
  if (pausado) video.pause(); else if (video.arrancar && !video.src) video.arrancar(); else video.play().catch(() => {});
  boton.setAttribute('aria-pressed', String(pausado));
  const texto = $('[data-pausa-texto]', boton) || boton;
  texto.textContent = pausado ? 'Reproducir vídeo' : 'Pausar vídeo';
};
botonesPausa.forEach(([selBoton, selSeccion]) => {
  $$(selBoton).forEach((b) => {
    const video = $('video', b.closest(selSeccion));
    if (!video) { b.hidden = true; return; }
    if (reducido() || (video.arrancar && navigator.connection?.saveData)) ponerPausa(b, video, true);
    b.addEventListener('click', () => ponerPausa(b, video, !video.paused));
  });
});

// Reseñas de la home: filtros y "leer más"
document.addEventListener('click', (e) => {
  const f = e.target.closest('[data-filtro-resena]');
  if (f) {
    const seccion = f.closest('[data-resenas]');
    const filtro = f.dataset.filtroResena;
    $$('[data-filtro-resena]', seccion).forEach((b) => b.setAttribute('aria-pressed', String(b === f)));
    $$('.resena-card', seccion).forEach((c) => {
      // La destacada solo se ve en grande con "Todas"
      c.dataset.destacada ??= c.classList.contains('resena-card--destacada') ? '1' : '0';
      c.classList.toggle('resena-card--destacada', filtro === 'todas' && c.dataset.destacada === '1');
      c.hidden = filtro !== 'todas' && c.dataset.cat !== filtro;
    });
    $('.resenas__pista', seccion)?.scrollTo({ left: 0 });
  }
  const m = e.target.closest('[data-leer-mas]');
  if (m) {
    const card = m.closest('.resena-card');
    card.classList.toggle('abierta');
    m.textContent = card.classList.contains('abierta') ? 'Leer menos' : 'Leer más';
  }
});

window.DBU = { $, $$, dinero, anadir, abrirCarrito, tostada, reducido, escapar, bloquearScroll, guardarFecha };
